module.exports = __webpack_public_path__ + "89fe1f8c7d4cc0a95eb96a834a289ef1.svg";